<template>
  <div class="map-page">
    <div class="map-hero">
      <div class="gs-hero-art" aria-hidden="true"></div>
      <div class="map-hero-inner">
        <div>
          <h1>数据地图</h1>
          <p>全国数据要素产业分布。点击省份，进入该区域服务商、产品与专家视图。</p>
        </div>
        <button v-if="currentLevel !== 'china'" type="button" class="map-back" @click="handleBack">返回全国</button>
      </div>
      <div class="map-metrics">
        <div v-for="item in statCards" :key="item.label" class="metric">
          <div class="metric-num"><em>{{ item.value == null || item.value === '' ? '-' : item.value }}</em>{{ item.unit }}</div>
          <div class="metric-label">{{ item.label }}</div>
        </div>
      </div>
    </div>

    <div class="map-body">
      <div class="map-head">
        <strong>数据要素产业分布图</strong>
        <span>颜色越深，服务商越多 · 点击省份下钻</span>
      </div>
      <div class="mapChina" id="mapChina" ref="china" />
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import geoJson from "../../views/mapComponent/mapData/china.json"
import { cityMap } from '@/views/mapComponent/mapData/citys/china-main-city-map.js'

import mapPro from './mapJson'
import requset from '@/utils/request.js'
import { applyBestChinaLayout, syncMapContainer, mapTooltipOption, mapPaint, mapVisualRange } from '@/utils/mapTooltip'
import { P } from '@/router/paths'
export default {
  name: 'chinaIndex',
  data() {
    return {
      chart: null,
      title: (this.$route.meta && this.$route.meta.title) || '',
      getMapRegionNumPlatformOutputList:[],
      /** 当前层级指标卡（/map/statistics 的 metrics） */
      mapMetricCards: [],
      currentRegionId: null,
      getMapStatisticsPlatformOutput: {
        dataServiceProvidersNum: '',
        dataProductsNum: '',
        dataExchange: '',
        dataAssetFinancingScale: '',
        dataInformationQuantity: ''
      },
      currentLevel: 'china', // 当前地图级别，默认为全国
      levelConfig: { // 地图层级配置，用于描述地图的层级关系
        china: {
          nextLevel: 'province', // 下一级，表示点击地图后，地图要跳转到的下一级
          geoKey: 'china',       // 地图key，表示地图的层级名称
          jsonPath: 'province'  // 地图json路径，表示地图json文件的存储路径
        },
        province: {
          nextLevel: 'city',
          geoKey: 'province',
          jsonPath: 'city'
        },
        city: {
          nextLevel: 'county',
          geoKey: 'city',
          jsonPath: 'county'
        }
      }
    }
  },
  computed: {
    scopeLabel() {
      if (this.currentLevel === 'city') return '本市'
      if (this.currentLevel === 'province') return '全省'
      return '全国'
    },
    statCards() {
      // 统一走 /map/statistics 的 metrics，与后台数据看板同一套口径
      const cards = this.mapMetricCards || []
      if (cards.length) {
        return cards.map((c) => ({
          label: this.scopeLabel + c.label,
          value: c.value,
          unit: c.unit
        }))
      }
      const s = this.getMapStatisticsPlatformOutput || {}
      const p = this.scopeLabel
      return [
        { label: p + '数据服务商', value: s.dataServiceProvidersNum, unit: '家' },
        { label: p + '数据产品', value: s.dataProductsNum, unit: '份' },
        { label: p + '数据交易所', value: s.dataExchange, unit: '个' },
        { label: p + '资讯数据', value: s.dataInformationQuantity, unit: '条' },
        { label: p + '行业专家', value: s.expertCount, unit: '人' }
      ]
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('resize', this.onMapResize)
    this.$nextTick(() => {
      this.initMap()
      this.bindMapObserver()
    })
  },
  beforeUnmount() {
    this.teardownMap()
  },
  beforeDestroy() {
    this.teardownMap()
  },
  created() {
    this.initData()
  },
  methods:{
    mapMode() {
      return window.innerWidth < 960 ? 'mobile' : 'page-desktop'
    },
    bindMapObserver() {
      const el = this.$refs.china
      if (!el || typeof ResizeObserver === 'undefined') return
      if (this._mapObs) this._mapObs.disconnect()
      this._mapObs = new ResizeObserver(() => {
        if (this._mapRoTick) return
        this._mapRoTick = true
        requestAnimationFrame(() => {
          this._mapRoTick = false
          this.onMapResize()
        })
      })
      this._mapObs.observe(el)
    },
    onMapResize() {
      clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => this.fitMap(), 120)
    },
    fitMap() {
      const el = this.$refs.china
      if (!el || !this.chart || this.chart.isDisposed()) return
      const mode = this.mapMode()
      syncMapContainer(el, mode === 'mobile')
      const w = el.clientWidth
      const h = el.clientHeight
      if (!w || !h) return
      if (w === this._lastMapW && h === this._lastMapH && mode === this._lastMapMode) return
      this._lastMapW = w
      this._lastMapH = h
      this._lastMapMode = mode
      const layout = {}
      applyBestChinaLayout(layout, mode)
      try { this.chart.setOption({ series: [layout] }) } catch (e) {}
      try { this.chart.resize({ width: w, height: h }) } catch (e) {}
    },
    teardownMap() {
      window.removeEventListener('resize', this.onMapResize)
      if (this._mapObs) {
        this._mapObs.disconnect()
        this._mapObs = null
      }
      if (this.chart && !this.chart.isDisposed()) {
        try {
          this.chart.off('click')
          this.chart.dispose()
        } catch (e) {}
      }
      this.chart = null
    },
    // 列表数据
    initData() {
      this.currentLevel = 'china'
      this.loadMapStatistics(null).then(() => {
        this.$nextTick(() => this.initMap())
      })
    },
    /** 统一地图统计接口：官网与后台同一套口径 */
    loadMapStatistics(regionId) {
      this.currentRegionId = regionId || null
      const url = regionId
        ? `/xwzx/map/statistics?regionId=${regionId}`
        : '/xwzx/map/statistics'
      return requset({ url, method: 'GET' }).then((res) => {
        const data = (res && res.data) || {}
        this.mapMetricCards = data.metrics || []
        this.getMapRegionNumPlatformOutputList = (data.rows || []).map((row) => ({
          name: row.name,
          regionId: row.regionId,
          level: row.level,
          canDrill: row.canDrill,
          dataServiceProvidersNum: row.dataServiceProvider,
          dataExchange: row.dataExchange,
          expertCount: row.expertCount,
          dataInformationQuantity: row.newsCount,
          dataSetCount: row.datasetCount,
          listingCount: row.listingCount,
          bookCount: row.bookCount,
          heat: row.heat
        }))
        return data
      }).catch(() => {
        this.mapMetricCards = []
        this.getMapRegionNumPlatformOutputList = []
        return {}
      })
    },
    // 列表数据
    initDataMap(data, mapCode) {
      const hit = (this.getMapRegionNumPlatformOutputList || []).find((r) => r.name === data)
      const regionId = hit && hit.regionId ? hit.regionId : null
      this.loadMapStatistics(regionId).then(() => {
        this.$nextTick(() => this.getMap(data, mapCode, this.getMapRegionNumPlatformOutputList))
      })
    },
    initMap() {
      let _this = this
      if (!_this.$refs.china) return
      this.getMap('china', geoJson, this.getMapRegionNumPlatformOutputList)
      var provinces = mapPro.provinceByName || {}
      if (this.chart) {
        this.chart.off('click')
        this.chart.on('click', async function(params) {
          if (!params || !params.name) return
          var name = params.name
          const currentConfig = _this.levelConfig[_this.currentLevel]
          if (!currentConfig) return
          if (currentConfig.nextLevel === 'province') {
            _this.$router.push(P.mapRegion(name))
            return
          }
          if (currentConfig.nextLevel === 'city') {
            try {
              _this.currentLevel = currentConfig.nextLevel
              const adcode = cityMap[name]
              const newGeoJsonCity = await import(`@/views/mapComponent/mapData/citys/${adcode}.json`)
              _this.initDataMap(name, newGeoJsonCity)
            } catch (error) {
              _this.currentLevel = 'province'
            }
          }
        })
      }
    },
    handleBack() {
      this.initData()
    },
    getMap(mapName, mapCode, allData) {
      const el = this.$refs.china
      if (!el || !mapCode) return
      echarts.registerMap(mapName, mapCode)
      const mobile = window.innerWidth < 960
      syncMapContainer(el, mobile)
      let myChart = (this.chart && !this.chart.isDisposed()) ? this.chart : (echarts.getInstanceByDom(el) || echarts.init(el))
      this.chart = myChart
      var fontSize = mobile ? '10px' : '12px'
      const list = (allData || []).map((d) => ({
        ...d,
        name: d.name || d.regionName,
        value: Number(d.heat != null ? d.heat : (d.dataServiceProvidersNum || d.value || 0))
      }))
      const seriesItem = mapPaint({
        name: 'MAP',
        type: 'map',
        map: mapName,
        mapType: mapName,
        aspectScale: 0.75,
        showLegendSymbol: false,
        zoom: 1,
        roam: false,
        label: {
          show: !mobile,
          fontSize: fontSize,
          color: '#16325c'
        },
        data: list
      })
      applyBestChinaLayout(seriesItem, this.mapMode())
      var option = {
        tooltip: mapTooltipOption(),
        visualMap: {
          type: 'continuous',
          min: 0,
          max: mapVisualRange(list),
          left: mobile ? 8 : 18,
          bottom: mobile ? 8 : 18,
          itemWidth: 10,
          itemHeight: mobile ? 56 : 88,
          text: ['多', '少'],
          textStyle: { color: '#5B6B82', fontSize: 11 },
          inRange: { color: ['#E7F0FF', '#8FBAFF', '#0165FF'] },
          hoverLink: false
        },
        series: [seriesItem]
      }
      myChart.setOption(option, true)
    }
  }
}
</script>
<style scoped>
.map-page {
  width: 100%;
  padding-bottom: 28px;
  overflow: visible;
  color: #1d2b44;
  position: relative;
}
.map-page::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  z-index: 0;
  pointer-events: none;
  background-color: #D7E7F8;
  background-image: url('@/assets/images/编组 65@2x.png');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
}
.map-hero,
.map-body {
  position: relative;
  z-index: 1;
}
.map-hero {
  position: relative;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  overflow: hidden;
  background: #0165FF;
}
.map-hero :deep(.gs-hero-art) {
  background-position: center;
}
.map-hero-inner,
.map-metrics {
  position: relative;
  z-index: 1;
  width: min(var(--gs-main-width, 1250px), calc(100% - 32px));
  margin: 0 auto;
}
.map-hero-inner {
  padding: 22px 0 16px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.map-hero h1 {
  margin: 0;
  font-size: 30px;
  line-height: 1.15;
  font-weight: 800;
  color: #fff;
}
.map-hero p {
  margin: 8px 0 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.88);
}
.map-back {
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.85);
  background: none;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
}
.map-metrics {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  padding-bottom: 22px;
}
.metric {
  padding: 0 18px;
  border-left: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
}
.metric:first-child {
  padding-left: 0;
  border-left: 0;
}
.metric-num {
  font-size: 13px;
  opacity: 0.9;
}
.metric-num em {
  font-style: normal;
  font-size: 28px;
  font-weight: 800;
  margin-right: 4px;
  letter-spacing: -0.5px;
}
.metric-label {
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.82;
}
.map-body {
  width: 100%;
}
.map-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 0 10px;
  border-bottom: 1px solid #E6EAF0;
}
.map-head strong {
  font-size: 18px;
  font-weight: 700;
}
.map-head span {
  font-size: 13px;
  color: #7b889c;
}
.mapChina {
  height: 820px;
  width: 100%;
}
@media (max-width: 1249px) {
  .map-body {
    width: min(var(--gs-main-width, 1250px), calc(100% - 32px));
    margin: 0 auto;
  }
  .map-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 14px;
  }
  .metric:nth-child(3n + 1) {
    padding-left: 0;
    border-left: 0;
  }
}
@media (max-width: 960px) {
  .map-hero-inner,
  .map-metrics {
    width: calc(100% - 24px);
  }
  .map-hero-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .map-hero h1 { font-size: 22px; }
  .map-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .metric:nth-child(odd) {
    padding-left: 0;
    border-left: 0;
  }
  .metric-num em { font-size: 22px; }
  .mapChina {
    height: 86vw;
    min-height: 260px;
    max-height: 380px;
  }
  .map-head {
    flex-direction: column;
    gap: 4px;
  }
}
</style>